import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { userIsAdmin } from "../lib/adminImport";
import { ARCHIV } from "../lib/appRoutes";
import { ALBIS_ABOUT_LINE, ALBIS_CONTACT_EMAIL, ALBIS_COPYRIGHT_LINE } from "../lib/albisVoice";
import AdminErsteHaushalteLinkCard from "../components/AdminErsteHaushalteLinkCard/AdminErsteHaushalteLinkCard";
import NotificationSettingsCard from "../components/NotificationSettingsCard/NotificationSettingsCard";
import SchoolEmailSetupCard from "../components/SchoolEmailSetupCard/SchoolEmailSetupCard";

const MEHR_ITEMS = [
  {
    to: "/schule",
    icon: "🏫",
    title: "KiTa & Kindergarten",
    hint: "Termine aus Schul-E-Mails erkennen",
  },
  {
    to: "/verbesserungen",
    icon: "💬",
    title: "Mitgestalten",
    hint: "Feedback und Ideen für Albis",
  },
  {
    to: "/news",
    icon: "📰",
    title: "News",
    hint: "Regional und für Familien",
    adminOnly: true,
  },
  {
    to: ARCHIV,
    icon: "📦",
    title: "Archiv",
    hint: "Plan & Entdecken (nicht gepflegt)",
    adminOnly: true,
  },
  {
    to: "/admin/activities-import",
    icon: "⚙️",
    title: "Activities import",
    hint: "CSV-Import für Activities",
    adminOnly: true,
  },
  {
    to: "/admin/nudges",
    icon: "🔔",
    title: "Push planen",
    hint: "Erinnerungen an Nutzer planen",
    adminOnly: true,
  },
  {
    to: "/admin/regional-calendars",
    icon: "📅",
    title: "Regionale Kalender",
    hint: "Ferien & Feiertage prüfen",
    adminOnly: true,
  },
  {
    to: "/admin/school-inbox",
    icon: "📬",
    title: "Schul-E-Mails",
    hint: "Erkennungsqualität prüfen",
    adminOnly: true,
  },
];

function MehrMenuTile({ item }) {
  return (
    <li>
      <Link to={item.to} className="mehr-list-link">
        <span className="mehr-list-icon" aria-hidden="true">
          {item.icon}
        </span>
        <span className="mehr-list-body">
          <span className="mehr-list-title-row">
            <span className="mehr-list-title">{item.title}</span>
            {item.adminOnly ? (
              <span className="mehr-list-admin-badge">Admin</span>
            ) : null}
          </span>
          <span className="mehr-list-hint">{item.hint}</span>
        </span>
        <span className="mehr-list-chevron" aria-hidden="true">
          ›
        </span>
      </Link>
    </li>
  );
}

export default function MehrPage() {
  const { user } = useAuth();
  const isAdmin = userIsAdmin(user);
  const menuItems = MEHR_ITEMS.filter((item) => !item.adminOnly || isAdmin);

  return (
    <div className="mehr-page">
      <header className="mehr-header">
        <h2 className="mehr-title">Mehr</h2>
        <p className="mehr-subtitle">
          Werkzeuge und Inhalte — Albis im Chat ist der Einstieg für den Alltag.
        </p>
      </header>

      <NotificationSettingsCard />

      {user ? <SchoolEmailSetupCard /> : null}

      <ul className="mehr-list">
        {menuItems.map((item) => (
          <React.Fragment key={item.to}>
            {isAdmin && item.to === ARCHIV ? (
              <li className="mehr-list-embedded-card">
                <AdminErsteHaushalteLinkCard />
              </li>
            ) : null}
            <MehrMenuTile item={item} />
          </React.Fragment>
        ))}
      </ul>

      <footer className="mehr-about">
        <p className="mehr-about-line">
          {ALBIS_ABOUT_LINE} · {ALBIS_COPYRIGHT_LINE} ·{" "}
          <a href={`mailto:${ALBIS_CONTACT_EMAIL}`}>{ALBIS_CONTACT_EMAIL}</a>
        </p>
      </footer>
    </div>
  );
}
